import Action from 'actions';
import BaseLP from 'services/sports/default/base-lp';
import Const from 'constants';
import {calcQuantityOfReservedLineupsByExposure, countPlayerIdInLineups} from 'helpers/lineup-helper';
import {addRoleSuffix, getSimplexUnitName} from 'helpers/simplex-helper';
import {getPlayerService} from 'services/sports/factory';

export default class LpSinglegame extends BaseLP {
    modes = [Const.CAPTAIN_MODE, Const.FLEX_MODE];

    createGroupsOfStacks({incomingValues: {dispatch}}) {
        const {
            playersData: {preparedPlayers},
        } = Action.getState();
        dispatch(Action.do('createGroupsOfPositionStacks', preparedPlayers.groupedBy.teamAndPosition()));
    }

    preparePlayerByLPPlayerId({incomingValues: {id}}) {
        const state = Action.getState();
        const {preparedPlayers} = state.playersData;
        const playersGroupedById = preparedPlayers.groupedBy.playerId();

        let unit = id.replace(Const.LP_UNIT_PREFIX, '').split(Const.LP_ITEM_DELIMITER);

        let player = {...playersGroupedById[unit[0]]};

        if (Const.LP_CAPTAIN_PLAYER_POSITION == unit[1]) {
            player.setAsCaptain();
        }

        return player;
    }

    prepareMaxSection({incomingValues = {}}) {
        return this.exec('prepareMaxSection_ShowDown', {
            modes: this.modes,
        });
    }

    prepareMaxRandomSection({incomingValues = {}}) {
        const state = Action.getState();
        const {preparedPlayers} = state.playersData;
        const {randomPoints} = state;
        const players = preparedPlayers.groupedBy.playerId();
        const {rawLineups} = state.lineupsData;
        const lineupNumber = 1 + rawLineups.getQuantity();

        const result = {};

        if (randomPoints.items.hasOwnProperty(lineupNumber)) {
            const pointsList = randomPoints.items[lineupNumber];
            Object.keys(players).map((pId) => {
                this.modes.map((mode) => {
                    const key = addRoleSuffix({prefix: pId, role: mode});
                    key in pointsList && (result[getSimplexUnitName(key)] = pointsList[key] * 1);
                });
            });
        }

        return {...result};
    }

    prepareSectionByTeam({incomingValues = {}}) {
        const {
            sportConfig,
            playersData: {preparedPlayers},
        } = Action.getState();
        const teams = preparedPlayers.groupedBy.property('team', []);

        let result = '';
        Object.keys(teams).map((teamName) => {
            let players = teams[teamName];
            players.map((player) => {
                const prefix = '+' + getSimplexUnitName(player.playerId);
                this.modes.map((mode) => (result += addRoleSuffix({prefix, role: mode})));
            });
            result += '<=' + sportConfig.getConfigProp('maxSingleTeamPlayers') + '\n';
        });

        return result;
    }

    prepareSectionByUniquePosition({incomingValues = {}}) {
        const state = Action.getState();
        const {playersLock} = state;
        const {preparedPlayers} = state.playersData;
        const players = preparedPlayers.groupedBy.playerId();
        let result = '';

        Object.values(players).map((player) => {
            const prefix = '+' + getSimplexUnitName(player.getId());
            const locked = [];
            const notLocked = [];

            this.modes.map((mode) => {
                if (playersLock.isLocked(player.getId(), mode)) {
                    locked.push(addRoleSuffix({prefix, role: mode}));
                } else {
                    notLocked.push(addRoleSuffix({prefix, role: mode}));
                }
            });

            if (!isEmpty(locked)) {
                result += locked.join('') + '=1\n';
                if (!isEmpty(notLocked)) {
                    result += notLocked.join('') + '=0\n';
                }
            } else if (!isEmpty(notLocked)) {
                result += notLocked.join('') + '<=1\n';
            }
        });

        return result;
    }

    prepareSectionBySpecialPosition({incomingValues = {}}) {
        const state = Action.getState();
        const {preparedPlayers} = state.playersData;
        const playersGroupedById = preparedPlayers.groupedBy.playerId();

        let captains = '';
        Object.keys(playersGroupedById).map((pId) => {
            let prefix = '+' + getSimplexUnitName(pId);
            captains += addRoleSuffix({prefix, role: Const.CAPTAIN_MODE});
        });
        if (captains.length) {
            captains += '=1\n';
        }

        return captains;
    }

    prepareSectionBySalary({incomingValues = {}}) {
        return this.exec('prepareSectionBySalary_ShowDown', incomingValues);
    }

    prepareSectionByPlayer({incomingValues = {}}) {
        const {
            sportConfig,
            playersData: {preparedPlayers},
        } = Action.getState();
        const playersGroupedById = preparedPlayers.groupedBy.playerId();

        let result = '';
        Object.keys(playersGroupedById).map((pId) => {
            const prefix = '+' + getSimplexUnitName(pId);
            this.modes.map((mode) => (result += addRoleSuffix({prefix, role: mode})));
        });
        result += '=' + sportConfig.getConfigProp('playersInTeam');

        return result;
    }

    prepareSectionByCreatedLineups({incomingValues = {}}) {
        const {sportConfig, uniquePlayersQuantity} = Action.getState();

        let result = '';
        this.store.get('lineups', []).map((lineup) => {
            result += lineup;
            let residual =
                sportConfig.getConfigProp('playersInTeam') - uniquePlayersQuantity.getUniquePlayersQuantity();
            result += '<=' + residual + '\n';
        });

        return result;
    }

    prepareSectionByExposureMax({incomingValues = {}}) {
        return this.exec('prepareSectionByExposureMax_ShowDown', incomingValues, {});
    }

    prepareSectionByExposureMin({incomingValues = {}}) {
        return this.exec('prepareSectionByExposureMin_ShowDown', incomingValues);
    }

    // prepareSectionByExposureMin({incomingValues = {}}) {
    //     const denyConstraints = this.store.get('denyConstraints', []);

    //     let result = '';
    //     if (inArray('exposureMin', denyConstraints)) {
    //         return result;
    //     }

    //     const {
    //         sportConfig,
    //         lineupsQuantity,
    //         playersData: {preparedPlayers},
    //     } = Action.getState();
    //     const availablePositions = {
    //         [Const.CAPTAIN_MODE]: 1,
    //         [Const.DEFAULT_MODE]: sportConfig.getPlayersInTeam() - 1,
    //     };
    //     const forbiddenPlayers = this.store.get('playersForbiddenByExposureMax', []);

    //     let hardConstraints = '';
    //     let expLine = '';
    //     let amountCoefficients = 0;
    //     let positionsCoefficient = {};
    //     let residualLineupsQ = lineupsQuantity.getLineupsQuantity() - this.store.get('calculatedLineupsCount', 0);

    //     Object.keys(availablePositions).map((playerMode) => {
    //         const expMinPropName = getPlayerService(sportConfig).exec('definePropNameOfMode', {
    //             prop: 'exposureMin',
    //             mode: playerMode,
    //         });
    //         const playersGroupedByExposureMin = preparedPlayers.groupedBy.property(expMinPropName);

    //         if (isEmpty(playersGroupedByExposureMin)) {
    //             return;
    //         }

    //         Object.values(playersGroupedByExposureMin).map((players) => {
    //             players.map((player) => {
    //                 if (player.isExcludedByMode(playerMode, {salaryMode: Const.FLEX_MODE})) {
    //                     return;
    //                 }

    //                 let lpPlayerId = addRoleSuffix({prefix: player.getId(), role: playerMode});
    //                 let usedInLineups = countPlayerIdInLineups(lpPlayerId, this.store.get('lineups', []).join(''));
    //                 let reservedLineupsQ = calcQuantityOfReservedLineupsByExposure(
    //                     lineupsQuantity.getLineupsQuantity(),
    //                     player.getPropValueOfMode('exposureMin', playerMode),
    //                 );
    //                 let residualReservedLineupsQ = reservedLineupsQ - usedInLineups;

    //                 if (residualReservedLineupsQ > 0) {
    //                     if (residualReservedLineupsQ >= residualLineupsQ) {
    //                         if (!inArray(lpPlayerId, forbiddenPlayers)) {
    //                             hardConstraints += '+' + getSimplexUnitName(lpPlayerId) + '=1\n';
    //                         }
    //                     } else if (!inArray(lpPlayerId, forbiddenPlayers)) {
    //                         let coefficientReservedPlaces = residualReservedLineupsQ / residualLineupsQ;
    //                         if (!positionsCoefficient.hasOwnProperty(playerMode)) {
    //                             positionsCoefficient[playerMode] = 0;
    //                         }
    //                         positionsCoefficient[playerMode] += coefficientReservedPlaces;
    //                         expLine += '+' + getSimplexUnitName(lpPlayerId);
    //                     }
    //                 }
    //             });
    //         });
    //     });

    //     Object.keys(positionsCoefficient).map((playerMode) => {
    //         let coef = positionsCoefficient[playerMode];
    //         if (coef > availablePositions[playerMode]) {
    //             coef = availablePositions[playerMode];
    //         }
    //         amountCoefficients += coef;
    //     });

    //     if (amountCoefficients > 0 && expLine) {
    //         amountCoefficients = Math.ceil(amountCoefficients);
    //         if (amountCoefficients > sportConfig.getPlayersInTeam()) {
    //             amountCoefficients = sportConfig.getPlayersInTeam();
    //         }

    //         expLine += '>=' + amountCoefficients + '\n';
    //     }

    //     return hardConstraints + expLine;
    // }

    prepareSectionByStacks({incomingValues = {}}) {
        return this.exec('prepareSectionByStacks_ShowDown', incomingValues);
    }

    prepareGeneralSection({incomingValues = {}}) {
        const state = Action.getState();
        const {preparedPlayers} = state.playersData;
        const playersGroupedById = preparedPlayers.groupedBy.playerId();

        const result = [];
        Object.keys(playersGroupedById).map((pId) => {
            const prefix = getSimplexUnitName(pId);
            this.modes.map((mode) => result.push(addRoleSuffix({prefix, role: mode})));
        });

        return result;
    }

    prepareBoundSection({incomingValues = {}}) {
        const state = Action.getState();
        const {preparedPlayers} = state.playersData;
        const playersGroupedById = preparedPlayers.groupedBy.playerId();

        let result = {};
        Object.keys(playersGroupedById).map((pId) => {
            let player = playersGroupedById[pId];
            let prefix = getSimplexUnitName(pId);

            const isExcludedByCapMode = player.isExcludedByMode(Const.CAPTAIN_MODE, {
                salaryMode: Const.FLEX_MODE,
            });
            result[addRoleSuffix({prefix, role: Const.CAPTAIN_MODE})] = {
                atLeast: 0,
                atMost: isExcludedByCapMode ? 0 : 1,
            };

            const isExcludedByFlexMode = player.isExcludedByMode(Const.FLEX_MODE);
            result[addRoleSuffix({prefix, role: Const.FLEX_MODE})] = {
                atLeast: 0,
                atMost: isExcludedByFlexMode ? 0 : 1,
            };
        });
        //console.log("bound\n",result);
        return result;
    }

    subjectToPermanent() {
        const constraints = {
            players: this.exec('prepareSectionByPlayer', {}, ''),
            salary: this.exec('prepareSectionBySalary', {}, ''),
            projectedOwnershipCap: this.exec(
                'projectedOwnership',
                {
                    modes: this.modes,
                },
                '',
            ),
            teams: this.exec('prepareSectionByTeam', {}, ''),
            specialPositions: this.exec('prepareSectionBySpecialPosition', {}, ''),
            keyPlayerStacking: this.exec(
                'keyPlayerStacking',
                {
                    modes: this.modes,
                },
                '',
            ),
            projectionBoostRule: this.exec(
                'projectionBoostRule',
                {
                    modes: this.modes,
                },
                '',
            ),
        };

        return {...constraints};
    }

    subjectToAlterable() {
        const constraints = {
            uniquePositions: this.exec('prepareSectionByUniquePosition', {}, ''),
            createdLineups: this.exec('prepareSectionByCreatedLineups', {}, ''),
            singlegameForcedStacking: this.exec('singlegameForcedStacking', {}, ''),
            exposureMax: this.exec(
                'prepareSectionByExposureMax',
                {
                    modes: this.modes,
                },
                '',
            ),
            exposureMin: this.exec('prepareSectionByExposureMin', {}, ''),
            playerCombinationStacking: this.exec(
                'playerCombinationStacking',
                {
                    modes: this.modes,
                },
                '',
            ),
        };

        return {...constraints};
    }
}
